<template>
  <vx-card id="term" class="vs-con-loading__container">
    <div class="flex flex-wrap justify-between">
      <div class="flex">
        <h4 class="mt-2">{{ name }}</h4>
        <feather-icon @click="isFormActive = true" class="ml-4" icon="Edit3Icon" svg-classes="cursor-pointer hover:text-primary"/>
      </div>
      <div class="flex flex-wrap">
        <vs-button v-if="!status" @click="setAsCurrent" class="mt-2 mr-2" color="warning">تعيين كفصل الحالي</vs-button>
        <vs-button v-if="!status" @click="deleteTerm" class="mt-2" color="danger" icon="icon-trash" icon-pack="feather" icon-after>حذف الفصل الدراسي</vs-button>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-table pagination search class="my-5" no-data-text="لا يوجد مواد دراسية في هذا الفصل" :data="coursesTerm" :total="coursesTerm.length">
          <template slot="thead">
            <vs-th sort-key="course_name">المادة</vs-th>
            <vs-th sort-key="teacher_name">الإستاذ</vs-th>
            <vs-th sort-key="group">المجموعة</vs-th>
            <vs-th>العمليات</vs-th>
          </template>
          <tbody slot-scope="{data}">
          <vs-tr v-if="hasRole('update_terms')">
            <vs-td>
              <v-select v-model="courseTermData.course" :options="courses" :getOptionLabel="option => `${option.name} ${option.id}`" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-validate="'required'" data-vv-scope="add" name="course">
                <template v-slot:option="option">{{ option.name }} ({{option.id}})</template>
                <div slot="no-options">عذرا ، لا توجد خيارات مطابقة</div>
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('add.course')">يجب تحديد المادة الدراسية</span>
            </vs-td>
            <vs-td>
              <v-select v-model="courseTermData.teacher" :options="teachers" :getOptionLabel="option => `${option.first_name} ${option.last_name}`" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-validate="'required'" data-vv-scope="add" name="teacher">
                <template v-slot:option="option">{{ option.first_name }} {{option.last_name}}</template>
                <div slot="no-options">عذرا ، لا توجد خيارات مطابقة</div>
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('add.teacher')">يجب تحديد الأستاذ</span>
            </vs-td>
            <vs-td>
              <v-select v-model="courseTermData.group" :options="groups" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-validate="'required'" data-vv-scope="add" name="group">
                <div slot="no-options">عذرا ، لا توجد خيارات مطابقة</div>
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('add.group')">يجب تحديد المجموعة</span>
            </vs-td>
            <vs-td>
              <vs-button @click="addCourseToTerm" class="rounded-full" color="success" icon="icon-plus" icon-pack="feather" icon-after>إضافة</vs-button>
            </vs-td>
          </vs-tr>
          <vs-tr v-for="(tr, index) in data" :data="tr" :key="index">
            <template v-if="editCourse !== tr">
              <vs-td :data="tr.course_name">
                {{ tr.course_name }}
                <span class="text-gray">({{tr.course_id}})</span>
              </vs-td>
              <vs-td :data="tr.teacher_name">{{ tr.teacher_name }}</vs-td>
              <vs-td :data="tr.group">{{ tr.group }}</vs-td>
              <vs-td>
                <div class="flex">
                  <vs-button v-if="hasRole('update_terms')" @click="editCourseTerm(tr, index)" size="large" title="تعديل" color="primary" type="flat" class="ml-2" icon-pack="feather" icon="icon-edit"></vs-button>
                  <vs-button v-if="hasRole('update_terms')" @click="deleteCourseTerm(tr)" size="large" title="حذف" color="danger" type="flat" icon-pack="feather" icon="icon-trash"></vs-button>
                </div>
              </vs-td>
            </template>
            <template v-else>
              <vs-td>
                <v-select v-model="updateCourseTermData.course" :options="courses" label="name"
                          v-validate="'required'" data-vv-scope="edit" name="course">
                  <template v-slot:option="option">{{ option.name }} ({{option.id}})</template>
                  <div slot="no-options">عذرا ، لا توجد خيارات مطابقة</div>
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('edit.course')">يجب تحديد المادة الدراسية</span>
              </vs-td>
              <vs-td>
                <v-select v-model="updateCourseTermData.teacher" :options="teachers" label="last_name"
                          v-validate="'required'" data-vv-scope="edit" name="teacher">
                  <template v-slot:option="option">{{ option.first_name }} {{option.last_name}}</template>
                  <div slot="no-options">عذرا ، لا توجد خيارات مطابقة</div>
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('edit.teacher')">يجب تحديد الأستاذ</span>
              </vs-td>
              <vs-td>
                <v-select v-model="updateCourseTermData.group" :options="groups"
                          v-validate="'required'" data-vv-scope="edit" name="group">
                  <div slot="no-options">عذرا ، لا توجد خيارات مطابقة</div>
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('edit.group')">يجب تحديد المجموعة</span>
              </vs-td>
              <vs-td>
                <span class="flex items-center">
                  <vs-button @click="editCourse = null" radius title="إلغاء" type="flat"  color="danger" icon="icon-x" icon-pack="feather" />
                  <vs-button @click="updateCourseTerm(tr)" class="rounded-full ml-2">حفظ</vs-button>
                </span>
              </vs-td>
            </template>
          </vs-tr>
          </tbody>
        </vs-table>
      </div>
    </div>
    <term-form @submit="save" :data="{ id: term_id, name: name }" :active.sync="isFormActive"/>
  </vx-card>
</template>

<script>
    import termsAPI from '@/api/admin/termsAPI'
    import coursesAPI from '@/api/admin/coursesAPI'
    import CourseForm from '@/views/admin/courses/CourseForm'
    import teachersAPI from '@/api/admin/teachersAPI'
    import courseTermAPI from '@/api/admin/courseTermAPI'
    import TermForm from '@/views/admin/TermForm'

    export default {
        components: { TermForm, CourseForm },
        name: 'courses-term',
        data() {
            return {
                name: '',
                status: 1,
                courseTermData: { course: null, teacher: null, group: null },
                updateCourseTermData: { course: null, teacher: null, group: null },
                editCourse: null,
                coursesTerm: [],
                courses: [],
                teachers: [],
                groups: [],
                isFormActive: false
            }
        },
        computed: {
            term_id() {
                return this.$route.params.term_id
            }
        },
        methods: {
            save(term) {
                this.name = term.name
            },
            deleteTerm() {
              const message = 'هل انت متأكد بأنك تريد حذف النقاش؟'
              this.$confirmAlert(null, message, () => {
                  termsAPI.delete(this.term_id)
                          .then(({successMessage}) => {
                              this.$notifySuccess(successMessage)
                              this.$router.go(-1)
                          })
                          .catch(error => this.$notifyError(error.statusMessage))
              })
            },
            addCourseToTerm(){
              this.$validator.validateAll('add').then((result) => {
                if(result){
                  let data = this.getRequestData(this.courseTermData)
                  courseTermAPI.create(data)
                    .then(response => {
                        if(response.data.message === 'exists'){
                            this.$notifyError('هذه المادة تم تسجيلها في نفس المجموعة مسبقا.')
                        } else {
                            let courseTerm = this.getCourseTermData(response.data.course_term_id, this.courseTermData)
                            this.coursesTerm.push(courseTerm)
                            this.courseTermData = this.clearData()
                            this.$validator.reset()
                            this.$notifySuccess(response.successMessage)
                        }
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                }
              })
            },
            deleteCourseTerm(course){
                let message = 'هل انت متأكد بأنك تريد حذف المادة من الفصل الدراسي'
                this.$confirmAlert(null, message, () => {
                    courseTermAPI.delete(course.id)
                        .then(response => {
                            let index = this.coursesTerm.indexOf(course)
                            this.$delete(this.coursesTerm, index)
                            this.$notifySuccess(response.successMessage)
                        })
                        .catch(error => this.$notifyError(error.statusMessage))
                })
            },
            editCourseTerm(courseTerm){
                let course = this.courses.find(course => {return course.id === courseTerm.course_id})
                let teacher = this.teachers.find(teacher => {return teacher.id === courseTerm.teacher_id})

                this.updateCourseTermData = {
                    term_id: this.term_id,
                    course: course,
                    teacher: teacher,
                    group: courseTerm.group
                }

                this.editCourse = courseTerm
            },
            updateCourseTerm(){
                this.$validator.validateAll('edit').then((result) => {
                    if(result) {
                        let data = this.getRequestData(this.updateCourseTermData)
                        let index = this.coursesTerm.indexOf(this.editCourse)
                        courseTermAPI.update(this.editCourse.id, data)
                            .then(response => {
                                if(response.data.message === 'exists') {
                                    this.$notifyError('هذه المادة تم تسجيلها في نفس المجموعة مسبقا.')
                                } else {
                                    let courseTerm = this.getCourseTermData(this.editCourse.id, this.updateCourseTermData)
                                    this.$set(this.coursesTerm, index, courseTerm)
                                    this.editCourse = null
                                    this.$notifySuccess(response.successMessage)
                                }
                            })
                            .catch(error => this.$notifyError(error.statusMessage))
                    }
                })
            },
            clearData(){
                return { course: null, teacher: null, group: null }
            },
            getRequestData(data) {
                return Object.assign({}, {
                    term_id: this.term_id,
                    teacher_id: data.teacher.id,
                    course_id: data.course.id,
                    group: data.group
                })
            },
            getCourseTermData(id, data){
                return Object.assign({}, {
                    id: id,
                    course_id: data.course.id,
                    course_name: data.course.name,
                    teacher_id: data.teacher.id,
                    teacher_name: data.teacher.first_name + ' ' + data.teacher.last_name,
                    group: data.group,
                })
            },
            loadData(){
                this.$startLoading('#term', 'white')
                for(let i = 65; i<=90; i++){this.groups.push(String.fromCharCode(i))}
                teachersAPI.getAll().then(({data}) => this.teachers = data.teachers)
                coursesAPI.getAll().then(({data}) => this.courses = data)

                termsAPI.getById(this.term_id).then(({data}) => {
                    this.name = data.name
                    this.status = data.status
                    this.coursesTerm = data.course_terms
                }).finally(() => this.$closeLoading('#term'))
            },
            setAsCurrent() {
              const message = 'هل انت متأكد بأنك تريد جعل هذا الفصل هو الفصل الحالي؟ لن يتمكن أعضاء هيئة التدريس والطلبة من عرض موادهم المسجله في الفصل السابق وسيتم أتخاد هذا الفصل والمواد المسجله به هو الفصل الحالي، يمكنك العودة إلى الفصل السابق في أي وقت بجعله الفصل الحالي.'
              this.$confirmAlert(null, message, () => {
                this.$startLoading('#term', 'white')
                termsAPI.setAsCurrent(this.term_id).then(() => {
                  this.status = 1
                  this.$notifySuccess('لقد تم جعل هذا الفصل هو الحالي')
                }).finally(() => this.$closeLoading('#term'))
              }, 'warning')
            }
        },
        mounted() {
            this.loadData()
        },
    }

</script>
